import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CampaignsState, AddCampaignResponse } from './types';
import { addCampaign, fetchCampaigns, fetchInactiveCatchUsers, fetchInactiveInvitee, updateCampaign, deleteCampaign, sendManualNotification } from './actions';

const initialState: CampaignsState = {
  campaignAdding: 'idle',
  addCampaignMessage: null,
  addCampaignError: null,
  campaignsList: {
    trasformData: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  campaignsListLoading: 'idle',
  campaignsListError: null,
  inactiveInviteeList: null,
  inactiveInviteeLoading: 'idle',
  inactiveCatchUsersList: null,
  inactiveCatchUsersLoading: 'idle',
  campaignUpdating: 'idle',
  updateCampaignMessage: null,
  updateCampaignError: null,
  campaignDeleting: 'idle',
  deleteCampaignMessage: null,
  deleteCampaignError: null,
  sendingNotification: 'idle',
  notificationSentMessage: null,
  notificationSentError: null,
};

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    clearMessage(state) {
      state.addCampaignMessage = null;
      state.updateCampaignMessage = null;
      state.deleteCampaignMessage = null;
      state.notificationSentMessage = null;
    },
    clearError(state){
      state.addCampaignError= null;
      state.updateCampaignError = null;
      state.deleteCampaignError = null;
      state.notificationSentError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCampaign.pending, (state) => {
        state.campaignAdding = 'pending';
        state.addCampaignError = null;
      })
      .addCase(addCampaign.fulfilled, (state, action: PayloadAction<AddCampaignResponse>) => {
        state.campaignAdding = 'succeeded';
        state.addCampaignMessage = action.payload.message;
      })
      .addCase(addCampaign.rejected, (state, action) => {
        state.campaignAdding = 'failed';
        state.addCampaignError = (action.payload as any)?.message || 'Failed to add campaign';
      })

      .addCase(updateCampaign.pending, (state) => {
        state.campaignUpdating = 'pending';
        state.updateCampaignError = null;
      })
      .addCase(updateCampaign.fulfilled, (state, action: PayloadAction<AddCampaignResponse>) => {
        state.campaignUpdating = 'succeeded';
        state.updateCampaignMessage = action.payload.message;
      })
      .addCase(updateCampaign.rejected, (state, action) => {
        state.campaignUpdating = 'failed';
        state.updateCampaignError = (action.payload as any)?.message || 'Failed to update campaign';
      })

      .addCase(deleteCampaign.pending, (state) => {
        state.campaignDeleting = 'pending';
        state.deleteCampaignError = null;
      })
      .addCase(deleteCampaign.fulfilled, (state, action: PayloadAction<AddCampaignResponse>) => {
        state.campaignUpdating = 'succeeded';
        state.deleteCampaignMessage = action.payload.message;
      })
      .addCase(deleteCampaign.rejected, (state, action) => {
        state.campaignUpdating = 'failed';
        state.deleteCampaignError = (action.payload as any)?.message || 'Failed to delete campaign';
      })

      .addCase(fetchCampaigns.pending, (state) => {
        state.campaignsListLoading = 'pending';
        state.campaignsListError = null;
      })
      .addCase(fetchCampaigns.fulfilled, (state, action) => {
        state.campaignsListLoading = 'succeeded';
        state.campaignsList = action.payload.data;
      })
      .addCase(fetchCampaigns.rejected, (state, action: PayloadAction<any>) => {
        state.campaignsListLoading = 'failed';
        state.campaignsListError = action.payload.message;
      })

      .addCase(fetchInactiveCatchUsers.pending, (state) => {
        state.inactiveCatchUsersLoading = 'pending';
      })
      .addCase(fetchInactiveCatchUsers.fulfilled, (state, action) => {
        state.inactiveCatchUsersLoading = 'succeeded';
        state.inactiveCatchUsersList = action.payload;
      })
      .addCase(fetchInactiveCatchUsers.rejected, (state) => {
        state.inactiveCatchUsersLoading = 'failed';
      })

      .addCase(fetchInactiveInvitee.pending, (state) => {
        state.inactiveInviteeLoading = 'pending';
      })
      .addCase(fetchInactiveInvitee.fulfilled, (state, action) => {
        state.inactiveInviteeLoading = 'succeeded';
        state.inactiveInviteeList = action.payload;
      })
      .addCase(fetchInactiveInvitee.rejected, (state) => {
        state.inactiveInviteeLoading = 'failed';
      })

      .addCase(sendManualNotification.pending, (state) => {
        state.sendingNotification = 'pending';
        state.notificationSentError = null;
      })
      .addCase(sendManualNotification.fulfilled, (state, action: PayloadAction<AddCampaignResponse>) => {
        state.sendingNotification = 'succeeded';
        state.notificationSentMessage = action.payload.message;
      })
      .addCase(sendManualNotification.rejected, (state, action) => {
        state.sendingNotification = 'failed';
        state.notificationSentError = (action.payload as any)?.message || 'Failed to update campaign';
      })

  },
});
export const { clearMessage, clearError } = campaignsSlice.actions;
export default campaignsSlice.reducer;
